import { Component, Input } from '@angular/core';
import { ProviderOffice } from 'app/core/models/provider-office.model';

import { ProviderOfficeComponent } from '../provider-office/provider-office.component';

@Component({
    selector: 'app-provider-office-list-basic',
    templateUrl: './provider-office-list-basic.component.html',
    styleUrls: ['./provider-office-list-basic.component.scss'],
    imports: [ProviderOfficeComponent]
})
export class ProviderOfficeListBasicComponent {
  @Input() providerOffices: ProviderOffice[];
  @Input() loading: boolean;
}
